export default __webpack_public_path__ + "static/media/img-equipment-status.35b24cc4.png";